import { Stack, styled as muiStyled, Typography } from '@mui/material';

export const Container = muiStyled(Stack)(() => ({
  cursor: 'pointer',
}));

export const TextSelectedOrder = muiStyled(Typography)(() => ({
  fontWeight: 'bold',
}));
